[
  {
    "code": "IS-7",
    "name": "Austurland"
  },
  {
    "code": "IS-1",
    "name": "Höfuðborgarsvæði"
  },
  {
    "code": "IS-6",
    "name": "Norðurland eystra"
  },
  {
    "code": "IS-5",
    "name": "Norðurland vestra"
  },
  {
    "code": "IS-8",
    "name": "Suðurland"
  },
  {
    "code": "IS-2",
    "name": "Suðurnes"
  },
  {
    "code": "IS-4",
    "name": "Vestfirðir"
  },
  {
    "code": "IS-3",
    "name": "Vesturland"
  }
]